import React from 'react'
import _cx from 'classnames/bind'
// @ts-ignore no types
import _ from 'lodash'
// @ts-ignore no types
import { connect } from 'react-redux'
import {
  Grid,
  Text,
  TutorialTooltip,
  // @ts-ignore no types
} from '@adc/ui-adc'
import configment from '@adc/configment'
import type {
  ListingParty,
  CollateralAnalyticsProperty,
  CollateralAnalyticsData,
  CollateralAnalyticsPropertyInfo,
  CollateralAnalyticsNeighborhoodView,
  CollateralAnalyticsPublicSchools,
  Maybe,
} from '@adc/sdk/types'
import { usePropertyContext } from '../../context/property'
import { useListingContext } from '../../context/listing'
import SectionPanel from '../../components/sectionPanel'
import { useModalFeatures } from '../../hooks/useModalFeatures'
import PropertyGallery from './propertyGallery'
import ValuationDetails from './valuationDetails'
// @ts-ignore no types
import cls from './index.scss'
const cx = _cx.bind(cls)

interface DangerousSpanProps {
  content: string
}
const DangerousSpan = ({ content }: DangerousSpanProps) => (
  <span dangerouslySetInnerHTML={{ __html: content }} />
)
interface RealtyTrackReport extends CollateralAnalyticsData {
  comps: CollateralAnalyticsData['comparables']
  data: CollateralAnalyticsData
  rentals: CollateralAnalyticsPropertyInfo['propertylistArray']
  taxInfo: CollateralAnalyticsProperty['info']
  schools: CollateralAnalyticsPublicSchools['school']
  neighborhood: CollateralAnalyticsNeighborhoodView['areaanalysis']
  highlights: CollateralAnalyticsNeighborhoodView['communityfeatures']
  // this should be computed
  isAnalysisDataAvailable: boolean
  saleHistory: CollateralAnalyticsProperty['historicaltransactions']
  rentalRange: Maybe<{
    low: number
    high: number
    median: number
    estimated: number
  }>
  hidePIR: boolean
}
interface InvestmentInfoProps {
  featureFlags?: any
  isPropertyReportAvailable?: boolean
  realtyTrackReport?: RealtyTrackReport
  showRentalEstimate?: boolean
}
const InvestmentInfo = ({
  featureFlags,
  isPropertyReportAvailable,
  realtyTrackReport,
  showRentalEstimate,
}: InvestmentInfoProps) => {
  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()
  const { pushAuthQueueItem, toggleAuthModal } = useModalFeatures()
  const listingParties = _.keyBy(listing.parties, 'party_role')
  const brokerParty = listingParties?.BROKER as ListingParty
  const listingAgency = brokerParty?.party_name
  const handleToggleSaveProperty = (saveData: any) => {
    propertyActions?.toggleSaveProperty({
      ...saveData,
      listing,
      property,
      pushAuthQueueItem,
      toggleAuthModal,
    })
  }
  return (
    <SectionPanel elmId='investment_info' compact>
      <Grid divided>
        <Grid.Row>
          <Grid.Column
            computer={10}
            tablet={8}
            mobile={16}
            className={cx('property-gallery')}
          >
            <PropertyGallery featureFlags={featureFlags} />
            {listingAgency && (
              <Text size='tiny' color='gray' className='u-mt-1'>
                Listed by <DangerousSpan content={listingAgency} />
              </Text>
            )}
            <a
              target='_blank'
              data-elm-id='investment_info_sell_your_property_link'
              rel='noreferrer'
              href={
                featureFlags['fe.resi.enable-private-seller']
                  ? '/apps/api/session-handoff?redirect-to=' +
                    encodeURIComponent(
                      `${configment.get(
                        'SMARTSALE_HOST'
                      )}/sell/?utm_source=auction.com&utm_medium=referral&utm_campaign=pdpsl_old_00_000_000000_0000_0000&utm_term=&utm_content=`
                    )
                  : '/lp/sell-your-property/'
              }
            >
              Sell your property faster with{' '}
              {featureFlags['fe.resi.enable-private-seller']
                ? 'SmartSale.com'
                : 'Auction.com'}
            </a>
          </Grid.Column>
          <Grid.Column
            computer={6}
            tablet={8}
            mobile={16}
            className={cx('no-divider')}
          >
            <TutorialTooltip
              elmId='valuation_details_tutorial_tooltip'
              tutorial={2}
              header='Discover Profit Potential'
              position='left center'
              mobilePosition='top center'
              content='Learn about the potential return on this property.'
            >
              <ValuationDetails
                featureFlags={featureFlags}
                isPropertyReportAvailable={isPropertyReportAvailable}
                realtyTrackReport={realtyTrackReport}
                showRentalEstimate={showRentalEstimate}
                toggleSaveProperty={handleToggleSaveProperty}
              />
            </TutorialTooltip>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </SectionPanel>
  )
}

const mapStateToProps = (store: any) => ({
  savedAssetsIdentifiers: store.properties.savedAssetsIdentifiers,
  featureFlags: store.featureFlags,
  realtyTrackReport: store.propertyAnalytics.realtyTrackReport,
  showRentalEstimate:
    store.propertyAnalytics.isPropertyReportAvailable &&
    store?.listing?.listing_configuration?.is_rental_estimate_hidden === false,
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
})

export default connect(mapStateToProps)(InvestmentInfo)
